<template>
	<div class="grid-container">
		<h1>Les commerçants</h1>
		<div class="grid-x grid-padding-x">
			<div
					class="cell small-6 medium-4 large-4 xlarge-shrink"
					v-for="commercant in commercants"
					v-bind:key="commercant.id"
					v-show="!loader"
			>
				<div class="card text-center">
					<a v-bind:href="'commercant/' + commercant.id" :class="'commercant-' + commercant.id">
						<img v-bind:src="commercant.thumbnail"/>
					</a>
					<a v-bind:href="'commercant/' + commercant.id" class="card-section" :class="'commercant-' + commercant.id">
						<span class="card-title">{{ commercant.title }}</span>
					</a>
				</div>
			</div>
			<div class="cell large text-center" v-show="loader"><img src="/loader.svg"></div>
		</div>
	</div>
</template>

<script>
    export default {
        name: "Commercants",
        props: {},
        mounted() {
            this.$ga.page('/commercants');
            this.$store.dispatch({type: "fetchCommercants"});
        },
        computed: {
            commercants: function () {
                return this.$store.state.commercants;
            },
            loader: function () {
                return this.$store.state.loader;
            },
        }
    };
</script>